import React from 'react';
import LearnUpper from './learnUpper';
import LearnMiddle from './learnMiddle';
import LearnLower from './learnLower';

export default function Learn() {
  return (
    <>
      <LearnUpper />
      <LearnMiddle />
      <LearnLower />
    </>
  )
}